/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ContentWatchSettingsPaginationSlice', 'model/TrendTopicCommentPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./ContentWatchSettingsPaginationSlice'), require('./TrendTopicCommentPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.TrendTopicReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ContentWatchSettingsPaginationSlice, root.ForStractionServiceApi.TrendTopicCommentPaginationSlice);
  }
}(this, function(ApiClient, ContentWatchSettingsPaginationSlice, TrendTopicCommentPaginationSlice) {
  'use strict';




  /**
   * The TrendTopicReport model module.
   * @module model/TrendTopicReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>TrendTopicReport</code>.
   * @alias module:model/TrendTopicReport
   * @class
   */
  var exports = function() {
    var _this = this;



















  };

  /**
   * Constructs a <code>TrendTopicReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TrendTopicReport} obj Optional instance to populate.
   * @return {module:model/TrendTopicReport} The populated <code>TrendTopicReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Comments')) {
        obj['Comments'] = TrendTopicCommentPaginationSlice.constructFromObject(data['Comments']);
      }
      if (data.hasOwnProperty('MarketWatches')) {
        obj['MarketWatches'] = ContentWatchSettingsPaginationSlice.constructFromObject(data['MarketWatches']);
      }
      if (data.hasOwnProperty('UserID')) {
        obj['UserID'] = ApiClient.convertToType(data['UserID'], 'Integer');
      }
      if (data.hasOwnProperty('ScopeID')) {
        obj['ScopeID'] = ApiClient.convertToType(data['ScopeID'], 'Integer');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('Probability')) {
        obj['Probability'] = ApiClient.convertToType(data['Probability'], 'Integer');
      }
      if (data.hasOwnProperty('CreatedDate')) {
        obj['CreatedDate'] = ApiClient.convertToType(data['CreatedDate'], 'Date');
      }
      if (data.hasOwnProperty('PESTELAreaID')) {
        obj['PESTELAreaID'] = ApiClient.convertToType(data['PESTELAreaID'], 'Integer');
      }
      if (data.hasOwnProperty('CoordinateWithinScopeScale')) {
        obj['CoordinateWithinScopeScale'] = ApiClient.convertToType(data['CoordinateWithinScopeScale'], 'Number');
      }
      if (data.hasOwnProperty('CoordinateWithinPESTELScale')) {
        obj['CoordinateWithinPESTELScale'] = ApiClient.convertToType(data['CoordinateWithinPESTELScale'], 'Number');
      }
      if (data.hasOwnProperty('ParentID')) {
        obj['ParentID'] = ApiClient.convertToType(data['ParentID'], 'Integer');
      }
      if (data.hasOwnProperty('TopicTypeID')) {
        obj['TopicTypeID'] = ApiClient.convertToType(data['TopicTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('MarketID')) {
        obj['MarketID'] = ApiClient.convertToType(data['MarketID'], 'Integer');
      }
      if (data.hasOwnProperty('NameFI')) {
        obj['NameFI'] = ApiClient.convertToType(data['NameFI'], 'String');
      }
      if (data.hasOwnProperty('NameEN')) {
        obj['NameEN'] = ApiClient.convertToType(data['NameEN'], 'String');
      }
      if (data.hasOwnProperty('NameSE')) {
        obj['NameSE'] = ApiClient.convertToType(data['NameSE'], 'String');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {module:model/TrendTopicCommentPaginationSlice} Comments
   */
  exports.prototype['Comments'] = undefined;
  /**
   * @member {module:model/ContentWatchSettingsPaginationSlice} MarketWatches
   */
  exports.prototype['MarketWatches'] = undefined;
  /**
   * @member {Integer} UserID
   * @default 0
   */
  exports.prototype['UserID'] = 0;
  /**
   * @member {Integer} ScopeID
   * @default 0
   */
  exports.prototype['ScopeID'] = 0;
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Integer} Probability
   * @default 0
   */
  exports.prototype['Probability'] = 0;
  /**
   * @member {Date} CreatedDate
   */
  exports.prototype['CreatedDate'] = undefined;
  /**
   * @member {Integer} PESTELAreaID
   */
  exports.prototype['PESTELAreaID'] = undefined;
  /**
   * @member {Number} CoordinateWithinScopeScale
   */
  exports.prototype['CoordinateWithinScopeScale'] = undefined;
  /**
   * @member {Number} CoordinateWithinPESTELScale
   */
  exports.prototype['CoordinateWithinPESTELScale'] = undefined;
  /**
   * @member {Integer} ParentID
   */
  exports.prototype['ParentID'] = undefined;
  /**
   * @member {Integer} TopicTypeID
   */
  exports.prototype['TopicTypeID'] = undefined;
  /**
   * @member {Integer} MarketID
   */
  exports.prototype['MarketID'] = undefined;
  /**
   * @member {String} NameFI
   * @default ''
   */
  exports.prototype['NameFI'] = '';
  /**
   * @member {String} NameEN
   * @default ''
   */
  exports.prototype['NameEN'] = '';
  /**
   * @member {String} NameSE
   * @default ''
   */
  exports.prototype['NameSE'] = '';
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


